import { AxiosResponse } from 'axios';
import i18n from 'i18next';
import { generatePath } from 'react-router-dom';
import { API_URL, SHOW_LOGS } from 'config';
import ApiInstance from 'api/Base';
import { setUserAttributes } from 'lib/EventsProvider';
import {
  IEUserIdMatchParam,
  IUserBaseParams,
  IUpdateUserParams,
  IUserVerifyEmailAvailability,
  IEFamilyIddMatchParam,
  IUserGetAccountParams,
} from './@types';
import {
  URL_GET_USER,
  URL_GET_USER_ACCOUNT,
  URL_SET_ALIAS,
  URL_UPDATE,
  URL_VERIFY_EMAIL_AVAILABILITY,
} from './User.values';

class UserService {
  static instance: UserService;

  static getInstance(): UserService {
    if (!UserService.instance) UserService.instance = new UserService();
    return UserService.instance;
  }

  static getUser = ({ id, signal }: IUserBaseParams): Promise<AxiosResponse> =>
    ApiInstance.get(
      generatePath(URL_GET_USER, {
        [IEUserIdMatchParam.PARAM]: id as string,
      }),
      {
        signal,
      },
    );

  static setAlias = ({ id, signal }: IUserBaseParams): Promise<AxiosResponse> =>
    ApiInstance.post(
      generatePath(URL_SET_ALIAS, {
        [IEUserIdMatchParam.PARAM]: id as string,
      }),
      {},
      {
        signal,
      },
    )
      .then((response) => response)
      .catch((error) => Promise.reject(error));

  static update = ({ id, name, lastname, signal, locale = i18n.language }: IUpdateUserParams): Promise<AxiosResponse> =>
    ApiInstance.put(
      generatePath(URL_UPDATE, {
        [IEUserIdMatchParam.PARAM]: id as string,
      }),
      { name, lastname, locale },
      {
        signal,
      },
    )
      .then((response) => {
        setUserAttributes({
          name,
          lastname,
          $first_name: name,
          $last_name: lastname,
          userName: name,
          userLastName: lastname,
        });
        return response;
      })
      .catch((error) => {
        if (SHOW_LOGS) {
          console.info('UserService::Update::catch response', error);
        }
        // throw error;
        return Promise.reject(error);
      });

  static verifyEmailAvailability = ({ email, signal }: IUserVerifyEmailAvailability): Promise<AxiosResponse> =>
    ApiInstance.get(URL_VERIFY_EMAIL_AVAILABILITY, {
      signal,
      params: {
        q: email,
      },
    });

  static getAccount = ({ familyId, signal }: IUserGetAccountParams): Promise<AxiosResponse> =>
    ApiInstance.get(
      generatePath(URL_GET_USER_ACCOUNT, {
        [IEFamilyIddMatchParam.PARAM]: familyId as string,
      }),
      {
        signal,
        headers: {
          apiVersion: API_URL.versions.V4,
        },
      },
    );
}

export default UserService;
